module.exports = __webpack_public_path__ + "img/openapihub-logo.c82ab3b9.png";